import { AdminPageHeader } from "../../components/admin/AdminPageHeader";
import { EmptyState } from "../../components/ui/EmptyState";

export function TrainerGlossaryPage() {
  return (
    <div>
      <AdminPageHeader
        eyebrow="Coaching content"
        title="Glossary"
        description="Shared coaching terms will live here."
      />
      <EmptyState title="Glossary management is not built yet.">
        Plan assignment V1 focuses on meal and workout assignment.
      </EmptyState>
    </div>
  );
}
